/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import React from 'react'
import { func, object, string, bool } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { urlWithTrack } from '../../../helpers/common'
import { EMPTY_OBJECT, ARTICLES, EVENTS, COMPETITIONS } from '../../../utils/constants'
import ResponsiveImage from '../../ui/image/ResponsiveImage'
import AdLink from '../../ui/ad-link/AdLink'
import SaveButton from '../../ui/button/SaveButton'
import { articleMessages as messages } from '../messages'
import Insights from '../Insights'

const ARTICLE = 'article'
const EVENT = 'event'
const COMPETITION = 'competition'

const Article = ({ insights = EMPTY_OBJECT, item = EMPTY_OBJECT, classes, isBig, handleLinkClick, type, gridView }) => {
  const { url, featured_images = EMPTY_OBJECT, title, document_type } = item
  const featured_image = featured_images ? isBig ? featured_images.url_large : featured_images.url_medium : ''
  const trackedUrl = urlWithTrack(url, type)
  let docType = document_type

  switch (docType) {
    case ARTICLES:
      docType = ARTICLE
      break
    case EVENTS:
      docType = EVENT
      break
    case COMPETITIONS:
      docType = COMPETITION
      break
    default:
      docType = ARTICLE
      break
  }
  const imageProps = {
    large: { src: featured_image },
    small: { src: featured_images.url_medium },
    commonProps: { 'data-object-fit': 'cover' }
  }

  return (
    <Insights className={`gridview__item ${classes}`} {...insights}>
      <div className='gridview__image-wrapper'>
        <AdLink href={trackedUrl} onClick={handleLinkClick}>
          <ResponsiveImage imageProps={imageProps} />
        </AdLink>
      </div>

      <SaveButton title={title} image={featured_image} url={url} gridView={gridView} insights={insights} />

      <AdLink href={trackedUrl} onClick={handleLinkClick} className='gridview__content'>
        {/* title */}
        <div className='gridview__text'>
          <FormattedMessage {...messages[docType]} />
        </div>
        {/* title */}
        <h3 className='gridview__entry-title gridview__entry-article gridview__entry-clamped--2'>{title}</h3>
      </AdLink>
    </Insights>
  )
}

Article.propTypes = {
  handleLinkClick: func,
  item: object,
  insights: object,
  isBig: bool,
  classes: string,
  type: string,
  gridView: bool
}

export default React.memo(Article)